import { Component, OnInit } from "@angular/core";
import { BsModalRef } from "ngx-bootstrap/modal";
import { MatSnackBar } from "@angular/material/snack-bar";
import * as _ from "lodash";

import { CanDriveService } from "../../api-handlers/can-drive-handler.service";
import { ParksHandlerService } from "../../api-handlers/parks-handler.service";
import { VehiclesHandlerService } from "../../api-handlers/vehicles-handler.service";
import { ParkType } from "../../models/parkType";
import { Park } from "../../models/park";

@Component({
  selector: "edit-vehicle-modal",
  templateUrl: "./edit-vehicle-modal.component.html",
})
export class EditVehicleModalComponent implements OnInit {
  parkTypes: ParkType[];
  parks: Park[];
  visibleParks: Park[];
  selectedPark: Park;
  foundParkTypeID;
  selectedParkType;
  activeChecked: boolean;
  didUserEdit = false;
  errorMessage = "";
  isLoading = false;
  didChangePark = false;

  vehicleId?: string;
  parkId?: string;
  plate?: string;
  closed_at?: string;

  constructor(
    public bsModalRef: BsModalRef,
    private canDriveService: CanDriveService,
    private parkService: ParksHandlerService,
    private snackBar: MatSnackBar,
    private vehiclesService: VehiclesHandlerService
  ) {}

  ngOnInit() {
    this.activeChecked = this.closed_at === "0";

    (async () => {
      try {
        this.parkTypes = await this.parkService.getParkTypes();
        this.parks = await this.parkService.getAllParks();

        const foundPark = this.parks.find((park) => {
          return park.id === this.parkId;
        });

        this.foundParkTypeID = foundPark.type_id;

        this.selectedParkType = this.parkTypes.find((parkType) => {
          return parkType.id == this.foundParkTypeID;
        });

        this.visibleParks = this.parks.filter((park) => {
          return park.type_id == this.foundParkTypeID;
        });
        
        this.visibleParks.sort((primoParco, secondoParco) => primoParco.name.localeCompare(secondoParco.name));

        this.selectedPark = foundPark;
      } catch (error) {
        this.errorMessage = error.message;
      }
    })();
  }

  parkTypeChanged(parkType: ParkType) {
    this.selectedParkType = parkType;
    this.visibleParks = this.parks.filter((park) => {
      return park.type_id == parkType.id;
    });

    this.visibleParks.sort((primoParco, secondoParco) =>
      primoParco.name.localeCompare(secondoParco.name)
    );

    this.selectedPark = this.visibleParks[0];
    this.parkId = this.selectedPark.id;
    this.didUserEdit = true;
    this.didChangePark = true;
  }

  selectParkChange(event) {
    this.parkId = this.selectedPark.id;
    this.didUserEdit = true;
    this.didChangePark = true;
  }

  async onEditClick() {
    this.isLoading = true;

    try {
      let activeCanDriveCount = 0;
      let confirmed = false;
      const checkCanDriveRes =
        await this.canDriveService.getCanDriveByVehicleID(this.vehicleId);

      checkCanDriveRes.forEach(({ canDrives }) => {
        if (!canDrives.cdr_closed_at) {
          activeCanDriveCount++;
        }
      });

      if (activeCanDriveCount > 0) {
        if (
          confirm(
            "Il veicolo risulta inserito nella tabella delle Auto Autorizzate. Ricordati di gestire il veicolo nella sezione specifica dopo il trasferimento."
          )
        ) {
          confirmed = true;
        } else {
          this.snackBar.open("Modifiche cancellate", undefined, {
            duration: 3000,
          });
        }
      } else {
        confirmed = true;
      }

      if (confirmed) {
        const updateVehicleBody = {
          vhc_id: this.vehicleId + "",
          vhc_closed: this.activeChecked ? 0 : 1,
          vhc_park_id: this.parkId + "",
        };

        await this.vehiclesService.adminUpdateVehicle(updateVehicleBody);
        this.bsModalRef.hide();
        this.snackBar.open(`Veicolo ${this.plate} modificato`, undefined, {
          duration: 3000,
        });
      }
    } catch (error) {
      this.errorMessage = error.message;
    } finally {
      this.isLoading = false;
    }
  }
}
